import { GET_PERSONS } from './../constants/actionTypes'
import get from 'lodash/get'

const persons = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_PERSONS: {
      const page = get(action, 'data.page', {})
      const persons =
        page.page === 1
          ? get(action, 'data.persons', [])
          : [
              ...get(store, 'persons', []),
              ...get(action, 'data.persons', [])
            ]
      return {
        page,
        persons
      }
    }
    default:
      return store
  }
}

export default persons
